import { Navigate, useParams } from 'react-router'
import toNumber from 'lodash/toNumber'
import { buildNavPathTrader, ROUTE_ORDERS, ROUTE_RECEIVABLES } from '@klear/constants'
import { useReceivables } from '@/app/receivables/use-receivables'

export default function InvoiceRedirect() {
  const { traderId = '', orderId = '', orderEventId = '' } = useParams()
  const parsedTraderId = toNumber(traderId)
  const open = useReceivables(parsedTraderId)
  const completed = useReceivables(parsedTraderId, { completed: true })
  if (open.isLoading || completed.isLoading) return null

  const invoiceId = toNumber(orderEventId)
  const row = [...open.rows, ...completed.rows].find((candidate) => candidate.invoice.id === invoiceId)
  const to =
    row === undefined
      ? `${buildNavPathTrader(traderId, ROUTE_ORDERS, orderId)}?${new URLSearchParams({ orderEventId })}`
      : `${buildNavPathTrader(traderId, ROUTE_RECEIVABLES)}?${new URLSearchParams({ search: row.invoice.idDisplay })}`
  return <Navigate to={to} replace />
}
